


















































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import {
  CollectionDetailTabBasicItem,
  CollectionDetailTabBudgetItem,
  CollectionDetailTabLendItem,
  CollectionDetailTabLocationItem,
  CollectionDetailTabOtherItem,
  defaultCollectionDetailTabBasicItem,
  defaultCollectionDetailTabBudgetItem,
  defaultCollectionDetailTabLendItem,
  defaultCollectionDetailTabLocationItem,
  defaultCollectionDetailTabOtherItem
} from '@/components/templates/collection-detail'
import CollectionDetailTabBasic from '@/components/templates/collection-detail/CollectionDetailTabBasic.vue'
import CollectionDetailTabLocation from '@/components/templates/collection-detail/CollectionDetailTabLocation.vue'
import CollectionDetailTabBudget from '@/components/templates/collection-detail/CollectionDetailTabBudget.vue'
import CollectionDetailTabOther from '@/components/templates/collection-detail/CollectionDetailTabOther.vue'
import CollectionDetailTabLending from '@/components/templates/collection-detail/CollectionDetailTabLending.vue'

export interface CollectionDetailTabItem {
  basic: CollectionDetailTabBasicItem
  location: CollectionDetailTabLocationItem
  budget: CollectionDetailTabBudgetItem
  other: CollectionDetailTabOtherItem
  lend: CollectionDetailTabLendItem
}

export const defaultCollectionDetailTabItem = (): CollectionDetailTabItem => ({
  basic: defaultCollectionDetailTabBasicItem(),
  location: defaultCollectionDetailTabLocationItem(),
  budget: defaultCollectionDetailTabBudgetItem(),
  other: defaultCollectionDetailTabOtherItem(),
  lend: defaultCollectionDetailTabLendItem()
})

@Component({
  components: {
    CollectionDetailTabLending,
    CollectionDetailTabOther,
    CollectionDetailTabBudget,
    CollectionDetailTabLocation,
    CollectionDetailTabBasic
  }
})
export default class CollectionDetailTab extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  activeTab: number = 0

  get types(): string[] {
    const types = [
      '基本情報',
      '所在情報',
      `${this.isOrder ? '発注' : '受入'}／予算情報`,
      'メモ／その他情報',
      '貸出情報'
    ]

    return this.isOrder ? types.filter(type => type !== '貸出情報') : types
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  isActiveTab(value: number): boolean {
    return this.activeTab === value
  }

  @Emit('click:parent-collection-no-link')
  onClickParentCollectionNoLink(): void {}
}
